//types for auth
export const UPDATE_AUTH = "UPDATE_AUTH";
export const EMPTY_AUTH = "EMPTY_AUTH";

//types for user
export const UPDATE_USER_REDUCER = "UPDATE_USER";

//types for user detail
export const GET_ALL_USER = "GET_ALL_USER";
export const UPDATE_USER_PAGINATION = "UPDATE_USER_PAGINATION"
export const UPDATE_USER_DETAIL_REDUCER = "UPDATE_USER_DETAIL_REDUCER";

export const GET_CONGREGATIONS_REDUCER = "GET_CONGREGATIONS_REDUCER";
export const UPDATE_CONGREGATIONS_PAGINATION = "UPDATE_CONGREGATIONS_PAGINATION"
export const REQUESTED_CONGREGATIONS_REDUCER =
  "REQUESTED_CONGREGATIONS_REDUCER";
